import React from "react";
import AvailableMethodsCon from '$Deposits/Components/Components/AvailableMethods'
import Drawer from '../Components/Drawer'
import Modal from "./Modal";
import { bankCodeWriting } from "$Deposits/lib/LibCommonData";
import Select, { Option } from "rc-select";

class AvailableMethods extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isUniqueModalVisible:false
        };
    }
    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }



    render() {

        const {isUniqueModalVisible} = this.state;

        return (
            <>
                <AvailableMethodsCon
                    AvailableMethods={(propCon) => {
                        const {
                            methodCode,
                            availableMethods,
                            onChange,
                        } = propCon

                        return (
                            availableMethods.length > 1 ?
                                <>
                                    <p className="inputTitle" data-CN="存款渠道">ช่องทางฝากเงิน</p>
                                    <div className="methodCodeList">
                                        {
                                            availableMethods.map((item, index) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        className={`methodsCodeList ${methodCode == item.methodCode ? 'methodsListActive' : ''}`}
                                                        onClick={() => {
                                                            if(item.methodCode==="UniqueAmt"){
                                                                this.setState({
                                                                    isUniqueModalVisible: true,
                                                                })
                                                                return;
                                                            }
                                                            onChange(item.methodCode)
                                                        }}
                                                    >
                                                        <div className={`radioCheck ${item.methodCode === methodCode ? "radioChecked" : ""}`}/>
                                                        <label>{item.methodType}</label>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <Modal
                                        visible={isUniqueModalVisible}
                                        className="lbUniqueModal"
                                        onlyOkBtn={true}
                                        title={"แจ้งเตือน"}
                                        okText={"ปิด"}
                                        onOk={()=>{
                                            this.setState({
                                                isUniqueModalVisible:false
                                            })
                                            onChange("UniqueAmt")
                                        }}
                                    >
                                        เพื่อการปรับยอดที่รวดเร็วยิ่งขึ้น เราแนะนำให้ทำการฝาก<br/>
                                        ตามยอดที่ระบบระบุเท่านั้น
                                    </Modal>
                                </>
                                : <></>
                        )
                    }}

                    EZP={(propCon) => {
                        const {
                            methodCode,
                            availableMethods,
                            onChange,
                        } = propCon
                        return (
                            <MethodsDrawer
                                methodCode={methodCode}
                                availableMethods={availableMethods}
                                onChange={onChange}
                            />
                        )
                    }}

                    CTC={(propCon) => {
                        const {
                            methodCode,
                            availableMethods,
                            onChange,
                        } = propCon

                        return (
                            availableMethods.length > 0 ?
                                <>
                                    <p className="inputTitle" data-CN="存款渠道">ช่องทางการฝากเงิน</p>
                                    <div className="methodCodeList">
                                        {
                                            availableMethods.map((item, index) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        className={'methodCodeCTC ' + (methodCode == item.methodCode ? 'CTCactive' : 'CTC')}
                                                        onClick={() => { onChange(item.methodCode) }}
                                                    >
                                                        <div className={methodCode == item.methodCode ? 'activeSelect' : 'borderSelect'} />
                                                        <div className="CTCmethodName">
                                                            <h5>{item.methodType}</h5>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="CTC-tips">
                                        {
                                            methodCode == 'CHANNEL' ? 'ธุรกรรมจะถูกสร้างขึ้น \n เมื่อการโอนสำเร็จ' : 'ให้บริการผ่าน 3rd party'
                                        }
                                    </div>
                                </>
                                : <></>
                        )
                    }}
                />

            </>
        );
    }
}


export default AvailableMethods


export class MethodsDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bankModal: false,
            activeItem: '',
        };

    }
    render() {

        const { bankModal, activeItem } = this.state

        const {
            availableMethods,
            onChange,
        } = this.props
        const active = availableMethods && availableMethods.find((v) => { return v.methodCode == this.props.methodCode }) || false

        const { methodType, methodCode } = activeItem || active || {}
        return (
            <>
                {
                    availableMethods.length > 0 &&
                    <div className="drop-area">
                        <Select
                            showSearch={false}
                            value={methodType}
                            optionLabelProp="children"
                            onChange={(methodCode) => onChange(methodCode)}
                            getPopupContainer={() =>
                                document.querySelector(".drop-area")
                            }
                            suffixIcon={
                                <span className="drawerIcon"/>
                            }
                            disabled={availableMethods.length == 1}
                        >
                            {
                                availableMethods.map((value, index) => {
                                    return (
                                        <Option
                                            value={value.methodCode}
                                            key={value.methodCode + index}
                                        >
                                            <span className={'bankIcon-default'}/>
                                            <p className="inputViewName">{value.methodType}</p>
                                            {/*<span className="drawerIcon" />*/}
                                        </Option>
                                    )
                                })
                            }
                        </Select>
                    </div>
                }
            </>
        )
    }
}
